//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import * as Actions from "./actions"

//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selector = (state) => state.bingoModal;

//  -- Examples array selector --------

export const useBingoModal = () => {
    const bingoModal = useSelector(selector, shallowEqual)
    const dispatch = useDispatch()
    const invokeBingoModal = () => {
        dispatch(Actions.invokeBingoModal())
    }
    const revokeBingoModal = () => {
        dispatch(Actions.revokeBingoModal())
    }
    return [bingoModal, invokeBingoModal, revokeBingoModal];
}
